import React, { useEffect, useRef, useState } from "react";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
} from "antd";
import "../style.css";
import TextArea from "antd/lib/input/TextArea";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDisabledScreen from "../../../../dentail-indetifcation/components/d-reusable/CustomDisabledScreen";
import CustomCard from "../../../../dentail-indetifcation/components/d-reusable/CustomCard";
import CustomPrimaryButton from "../../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import {
  ageAssessmentBasePath,
  boneAndDentalHealthInfo,
  errorRequestHandel,
  medicalHisotryInfo,
  purposeOfAssessmentInfo,
  referringAgency,
} from "../../../../helper";
import {
  _onChangeSubjectRegistrationFormValues,
  _onResetCaseRegistrationForm,
} from "../../../../redux/actions/age-assessment/caseRegistrationAction";
import { assessmentIcons } from "../../../utils/assessmentIcons";
import CustomModal from "../../../components/modals/CustomModal";
import { useSubscriptionGuard } from "../../../../hooks/subscription-hook/UseSubscriptionGuard";

const { Option } = Select;

const steps = ["Subject Information", "Clinical Evaluation"];

const NewCaseRegistration = () => {
  useSubscriptionGuard();
  const location = useLocation();
  const { type, projectId, caseId } = location.state || {}; // Destructure state values

  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [isReferingAgency, setIsReferingAgency] = useState(false);
  const [isPurposeOfAssessment, setIsPurposeOfAssessment] = useState(false);
  const [isMedicalHistory, setIsMedicalHistory] = useState(false);
  const [isBoneAndHealth, setIsBoneAndHealth] = useState(false);
  const [isDateOrDob, setIsDateOrDob] = useState("");
  const [hasSubscription, setHasSubscription] = useState(false);
  const [isDob, setIsDob] = useState(false);
  const [loading, setLoading] = useState(false);
  const subject = useSelector((state) => state.ageAssessmentCase?.subject);
  const { dropdowns, countriesList = [] } = useSelector(
    (state) => state.general
  );

  const subjectInformation = subject;

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [location]);

  useEffect(() => {
    if (subjectInformation?.age_years.trim() !== "") {
      setIsDob(true);
    }
    setIsDateOrDob("fill");
  }, [location]);

  const handleValuesChange = (changedValues, allValues) => {
    const [field, value] = Object.entries(changedValues)[0];

    dispatch(_onChangeSubjectRegistrationFormValues(field, value));
  };

  const onFinish = async () => {
    navigate(`${ageAssessmentBasePath}/cases/new-case/dental-examination`);
  };

  const handleDobChange = (date) => {
    if (date) {
      setIsDateOrDob("dob"); // Set the state to "dob" when Date of Birth is selected
    } else if (!form.getFieldValue("age_years")) {
      setIsDateOrDob(""); // Reset if both fields are empty
    }
  };

  const handleAgeChange = (event) => {
    const value = event.target.value;
    if (value) {
      setIsDateOrDob("age_years"); // Set the state to "age_years" when Age is entered
    } else if (!form.getFieldValue("reported_dob")) {
      setIsDateOrDob(""); // Reset if both fields are empty
    }
  };

  return (
    <div className="d-case_registration" ref={scrollRef}>
      <CustomDisabledScreen loading={loading} />

      <CustomCard>
        <div className="d-case_form">
          <Form
            layout="vertical"
            className="basic_antForm"
            initialValues={{
              ...subjectInformation,
              reported_dob: subjectInformation?.reported_dob
                ? moment(subjectInformation?.reported_dob)
                : null,
            }}
            onFinish={onFinish}
            onValuesChange={handleValuesChange}
          >
            <Row gutter={[20, 5]}>
              <Col md={12}>
                <Form.Item
                  label={"Full Name"}
                  name="full_name"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <Input placeholder="Full Name" />
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item label="Nationality" name="nationality">
                  <Select
                    placeholder="Select"
                    showSearch
                    optionFilterProp="children" // Enables filtering based on the Option's text
                    filterOption={(input, option) =>
                      option?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    } // Custom filter function
                  >
                    {countriesList.map((item, index) => {
                      return (
                        <Option value={item.id} key={index}>
                          {item?.nice_name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item
                  label="Biological Sex"
                  name="gender"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <Select placeholder="Select">
                    {dropdowns?.gender.map((item, index) => {
                      return (
                        <Option value={item.id} key={index}>
                          {item.value}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col md={12}>
                <Row gutter={[10, 10]} align="middle">
                  <Col md={18}>
                    {!isDob ? (
                      <Form.Item label="Date of birth" name="reported_dob">
                        <DatePicker
                          placeholder="yyyy-mm-dd"
                          style={{
                            width: "100%",
                            height: "43px",
                            marginTop: 5,
                            marginBottom: 5,
                          }}
                          onChange={(date) => handleDobChange(date)}
                          disabledDate={(current) =>
                            current && current > moment().endOf("day")
                          } // Disable future dates
                        />
                      </Form.Item>
                    ) : (
                      <Form.Item
                        label="Stated Age"
                        name="age_years"
                        dependencies={["reported_dob"]}
                      >
                        <Input
                          placeholder="Age in Years"
                          type="number"
                          onChange={(event) => handleAgeChange(event)}
                        />
                      </Form.Item>
                    )}
                  </Col>

                  <Col
                    md={6}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Checkbox
                      checked={isDob}
                      onChange={(e) => setIsDob(e.target.checked)}
                    >
                      Age in Years
                    </Checkbox>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col md={12}>
                <Form.Item
                  label="Status"
                  name="status"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <Select placeholder="Select">
                    {dropdowns?.status.map((item, index) => {
                      return (
                        <Option value={item.id} key={index}>
                          {item.value}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item
                  label="Ancestry"
                  name="ethnicity"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <Select placeholder="Select">
                    {dropdowns?.ethnicity.map((item, index) => {
                      return (
                        <Option value={item.id} key={index}>
                          {item.value}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item label={"Height (CM)"} name="height">
                  <Input placeholder="" />
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item label={"Weight (KG)"} name="weight">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item
                  name="medical_history"
                  label={
                    <span>
                      Medical History
                      <img
                        src={assessmentIcons.aboutUsIcon}
                        style={{
                          height: 15,
                          margin: "0px 10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setIsMedicalHistory(true)}
                      />
                    </span>
                  }
                >
                  <TextArea
                    className="form_basic_text_area"
                    placeholder="Write medical history"
                  />
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item
                  name="bone_assessment"
                  label={
                    <span>
                      Bone & Dental Health
                      <img
                        src={assessmentIcons.aboutUsIcon}
                        style={{
                          height: 15,
                          margin: "0px 10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setIsBoneAndHealth(true)}
                      />
                    </span>
                  }
                >
                  <TextArea
                    className="form_basic_text_area"
                    placeholder="Write bone Assessment"
                  />
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item label="Identity Type" name="identity_type">
                  <Select>
                    {dropdowns?.identity_type.map((item, index) => {
                      return (
                        <Option value={item.value} key={index}>
                          {item.value}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item label="Identity Code" name="identity_number">
                  <Input placeholder="Enter Code" />
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item
                  // label="Referring Agency"
                  label={
                    <span>
                      Referring Agency
                      <img
                        src={assessmentIcons.aboutUsIcon}
                        style={{
                          height: 15,
                          margin: "0px 10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setIsReferingAgency(true)}
                      />
                    </span>
                  }
                  name="referring_agency"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item
                  label={
                    <span>
                      Purpose of Assessment
                      <img
                        src={assessmentIcons.aboutUsIcon}
                        style={{
                          height: 15,
                          margin: "0px 10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setIsPurposeOfAssessment(true)}
                      />
                    </span>
                  }
                  name="purpose_of_assessment"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>
              </Col>
            </Row>

            <br />

            <Row justify={"start"} gutter={[20, 20]}>
              <Col>
                <CustomPrimaryButton
                  title={"Next"}
                  type={"submit"}
                  isLoading={loading}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </CustomCard>

      <CustomModal
        open={isReferingAgency}
        onCancel={() => setIsReferingAgency(false)}
        width={700}
      >
        <div className="exam_observation_section">
          <h4>Entities Requesting Age Estimation:</h4>

          <ul>
            {referringAgency.map((condition, index) => (
              <li key={index}>{condition.title}</li>
            ))}
          </ul>
        </div>
      </CustomModal>
      <CustomModal
        open={isPurposeOfAssessment}
        onCancel={() => setIsPurposeOfAssessment(false)}
        width={700}
      >
        <div className="exam_observation_section">
          <h4>Reasons for Age Assessment:</h4>

          <ul>
            {purposeOfAssessmentInfo.map((condition, index) => (
              <li key={index}>{condition.title}</li>
            ))}
          </ul>
        </div>
      </CustomModal>
      <CustomModal
        open={isMedicalHistory}
        onCancel={() => setIsMedicalHistory(false)}
        width={700}
      >
        <div className="exam_observation_section">
          <h4>Medical History Affecting Age Assessment:</h4>

          <ul>
            {medicalHisotryInfo.map((condition, index) => (
              <li key={index}>{condition.title}</li>
            ))}
          </ul>
        </div>
      </CustomModal>
      <CustomModal
        open={isBoneAndHealth}
        onCancel={() => setIsBoneAndHealth(false)}
        width={700}
      >
        <div className="exam_observation_section">
          <h4>Factors Affecting Dental Health:</h4>

          <ul>
            {boneAndDentalHealthInfo.map((condition, index) => (
              <li key={index}>{condition.title}</li>
            ))}
          </ul>
        </div>
      </CustomModal>
    </div>
  );
};

export default NewCaseRegistration;
